let React = require("react");
let Dropdown = require("../buttons/generic/Dropdown.jsx");

class SelectSort extends React.Component {

    constructor(){
        super();

        this.state = { 
            dropdownName: "Recently added"
        }

        this.onSelected = this.onSelected.bind(this);
    }

    onSelected(name, value){
        this.props.onSelected(value)
        this.setState({dropdownName: name})
    }

    render() {
        return  <div className="selectSort">
                    <Dropdown 
                        options={[
                            {name: "Recently added", onClick: () => this.onSelected("Recently added", "add")},
                            {name: "Name (A-Z)", onClick: () => this.onSelected("Name (A-Z)", "az")},
                            {name: "Name (Z-A)", onClick: () => this.onSelected("Name (Z-A)", "za")},
                        ]}
                        name={this.state.dropdownName} 
                    />
                </div>
    }
};

module.exports = SelectSort;